<pbc-sorter [config]="RollesSorterConfig" [sorter]="rolles.sorter$ | async" (sorterChange)="rolles.sorter$.next($event)"></pbc-sorter>
